<template>
	<v-card outlined :height="currentHeight-150" :loading="info.loadingVideo">
		<v-card-title class = "title-2 secondary pa-1 white--text">	
			<v-icon 				
				color  = "white"
				class  = "ml-1"
				@click = "$router.back()"
			>
				mdi-arrow-left-circle
			</v-icon>
			<v-spacer></v-spacer>
			<AnimatedFaceDetection  class="mx-2"  mode="scanner" color="green" :size="27">
				<!-- class  = "mx-2" -->
				<v-icon				
					v-text = "'mdi-video-account'"
					color  = "white"
				></v-icon>
				
			</AnimatedFaceDetection>
			<!-- <AnimatedFaceDetection2></AnimatedFaceDetection2> -->
			<span v-text = "$ml.get('search_by_video_face')"></span>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-card-text class="pa-1">
			<div class="d-flex fill-height">
				<Sidebar :open="menus" :infoToFilter="info" :currentHeight="currentHeight-200"></Sidebar>
				<!-- <VideoPlayer></VideoPlayer> -->
				
				<v-dialog  transition="dialog-bottom-transition"  fullscreen v-model="menus.dialogVideo">
					<!-- <template v-slot:activator="{ on, attrs }">
						<v-btn color="primary"  right absolute
			            	height="40"
			            	width="130"
			            	class="mx-auto"
			            	v-bind="attrs" v-on="on"
						>
							{{$ml.get('results')}}
			          	</v-btn>
			        </template> -->
			        <template v-slot:default="dialog">
			        	<v-card outlined>
			        		
			        	<v-card-title>
							<v-btn color="error"  @click="menus.dialogVideo=false"><v-icon>mdi-close</v-icon></v-btn>
							<v-spacer></v-spacer>
							<strong> {{$ml.get('video')}}</strong>
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text class="pa-1">								
							<VideoSearch :videoUrl="info.videoUrl" :currentHeight="currentHeight" :infoToFilter="info" :isDialogOpen="menus.dialogVideo" @closeDialog="menus.dialogVideo=false" :Threshold="getThreshold"></VideoSearch>
						</v-card-text>
			        	</v-card>
					</template>
				</v-dialog>
				<v-container fluid class="pa-0 fill-height flex-grow-1">
      				
					<v-row class="fill-height" dense>
				
						<v-col>
						<!-- <v-btn >RESULTS</v-btn> -->
							<Results :open="menus" :infoToFilter="info" :currentHeight="currentHeight-200" ></Results>
						<!-- :error-messages="list_faces.length? messageErrorUpload:[]" -->
						</v-col>
					</v-row>
				</v-container>
			</div>
		</v-card-text>
		<!-- <v-card-actions>
			<v-bottom-navigation height="35">
				<v-btn @click="menus.sidebar = !menus.sidebar"> <v-icon>mdi-magnify</v-icon></v-btn>
				
				<v-btn color="primary" @click="AnalyzeVideo()">{{$ml.get('analyze_video')}}</v-btn>
			</v-bottom-navigation>
		</v-card-actions> -->
	</v-card>
</template>
<script type="text/javascript">
	import Sidebar from "@/components/face/SidebarSearchByVideo.vue"
	import Results from "@/components/face/ResultsSearchByVideo.vue"
	import VideoSearch from  "@/components/face/VideoSearchByVideo.vue"
	import AnimatedFaceDetection from "@/components/face/AnimatedFaceDetection.vue"
	// import AnimatedFaceDetection2 from "@/components/face/AnimatedFaceDetection2.vue"
	// import UploadFile from "@/components/face/UploadVideoSearch.vue"
	// import VideoPlayer from "@/components/face/VideoPlayer.vue"

	export default{
		name: "SearchByVideoFaceView",
		components:{ Sidebar, Results, VideoSearch, AnimatedFaceDetection}, // UploadFile , VideoPlayer, AnimatedFaceDetection2
		data:()=>({
			info:{
				videoFile : null,
				tagsFile : [],
				tags : [], // upload_imagen
				videos: [],
				videoUrl : null,
				videoUrlPreload : null,
				uuid : null,
				similarity : 25,
				results : [ 
					// { data: [ { isVideoLoaded:false,"userId": "1599", "photo_uuid": "f193edf5-fba4-4f22-a6c9-c01c71b00d55", "bbox": { "x": 0.28103, "y": 0.270833, "w": 0.433255, "h": 0.533333 }, "faceId": 1596, "similarity": 0.107205, "path": "/alert/2024/12/6/1735399121243/1735399121243_photo.jpg", "frame_idx": "1599", "infovideo": { "id": 8, "fps": 24, "frameHeight": 480, "frameWidth": 854, "requestUuid": "f64905fb-3af8-48c3-9736-ee20269e17cd", "status": "200", "total_faces": 700, "total_frames": 3590, "path": "/opt/alice-media/faces/file-1735358497969-WhatsApp_Video_2024-12-20_last.mp4", "url": "/faces/file-1735358497969-WhatsApp_Video_2024-12-20_last.mp4", "createdAt": "2024-12-28T04:02:51.269Z", "updatedAt": "2024-12-28T04:02:51.269Z" }, "currentTime": 66.625 } 
					// ]}
				],
				deviceSelecteds : [],
				loadingVideo : false,
				videosSelected: null,
				tagsSelected: [],
				selectedVideoDialog:null,
				currentTimeVideo : 0,
				faceListSelecteds:[],
				isUploadingVideo  : false,

			},
			loading: false,
			menus:{
				sidebar :true,
				dialogVideo : false,
			},
			bus : {},
		}),
		mounted(){
			this.$Format.update_list('ml', this.$ml);
			this.$EventBus.$on("load_videodb", this.bus.load_videodb=(msg)=>{
				// console.log("CHECK LOAD VIDEO DB ", msg)
				this.info.isUploadingVideo=true;
				
				if(msg?.uuid){
					const find=this.info.videos.find(x=> x.uuid == msg.uuid || x.uuid == msg.UUID) 
					if(find){
						console.log(msg,"msg")
						if(msg.type == 'preload'){
							find.msg =	`${this.$ml.get('uploading_video')} ${msg.percent}`;
						}
						else if(msg.type == 'processing'){
							find.msg =	`${msg.type} ${msg.percent}`;
						}
						else if(['analized'].includes(msg.type)){
							if(msg.msg=="starting to process video"){
								find.msg=`${this.$ml.get('analyzing_video')} ${msg.percent}`;
							}else
							if([100].includes(msg.percent)){
								find.msg=this.$ml.get('analysis_completed');
								this.$nextTick(()=>{
									find.date=find.createdAt?this.$Helper.formatDate(find.createdAt, "createdAt") : this.$Helper.getDateFormat(new Date, 'YYYY-MM-DD HH:mm');// ll, LTS
								})
								// find.msg=this.$ml.get('analysis_completed');
								find.clear=setTimeout(()=>{
									find.loading=false;
									const {tagsSelected, faceListSelecteds} =this.info
									if(tagsSelected.length == 0  &&  faceListSelecteds.length==0){
										find.msg=this.$ml.get("face_needs_selected");
									}else{
										find.msg=this.$ml.get("selection_successfully") + ", " + this.$ml.get("now_you_can_perform_search");
									}
									find.clear2=setTimeout(()=>{
										find.msg=""+msg.total_faces;
										clearTimeout(find.clear)
										clearTimeout(find.clear2)
									}, 3500)
								},5000)
								if(find.uuid == this.info.uuid){									
									this.info.videosSelected=find;
									this.info.videoUrlPreload=find?.urlVideo || find?.urlVideoPreload;
								}
								this.info.isUploadingVideo=false;

							}
						} 
						else if(msg.type == 'error'){
							if(msg.detail.includes('uploading')){
								find.msg=this.$ml.get("error_uploading_video_face")
							}else{
								find.msg=msg.detail
							}
							// Reset isUploadingVideo on error to re-enable upload button
							this.info.isUploadingVideo=false;
						}
						
					}

				}
			});
		},
		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus,this.bus, "searchVideoByFace")
		},
		watch:{
			"info.videoFile"(val){
				if(val){
					this.AnalyzeVideo();						
				}
			}
		},
		computed: {
			currentHeight(){
				return this.$vuetify.breakpoint.height;
			},
			getThreshold(){
				return this.info?.similarity ? (this.info.similarity/100):0;
			},
		},
		methods:{
			
			async AnalyzeVideo(){
				try{
					// load_videodb
					this.loading=true;
					this.info.loadingVideo=true;
					let formData = new FormData();
					let info_up = {...this.info};
					for(let it in info_up){		        	
				        if (it && info_up[it] && !["videoFile", "tagsFile", "loadingVideo", "deviceSelecteds", "tagsSelected", "videosSelected", "results", "videos", "tags", "currentTimeVideo", "faceListSelecteds", "similarity", "videoUrlPreload", "isUploadingVideo"].includes(it)) {
			        		formData.append(it, info_up[it]);
				        }
		        	}
		        	formData.append("file", info_up.videoFile);
					const uri=this.$URL+"/api/v1/preloadvideo"
					const res = await this.$axios.post(uri,formData)
						// console.log("CHECK RESPONSE ",res)
					/*if(res && res.data && res.data.result){
						this.info.results=res.data.result.map(x=> {
							x.isVideoLoaded=false
							return x
						});;
					}else{
						this.info.results=[];
					}*/
					if(res?.data?.status && res?.data?.status == 'error'){
						// if(res?.data?.msg){
						this.$EventBus.$emit("notifications_modal",{ type : "warning", message: this.$ml.get("error_reading_video")})
						// }
						const find=this.info.videos.find(x=> x.uuid == info_up.uuid)
						if(find){
							find.isInvalid=true;
							find.loading=false;
							find.msg=res?.data?.msg;
							this.info.videos.splice(idx, 1, find)
						}
					}else{
						const find=this.info.videos.find(x=> x.uuid == info_up.uuid)
						if(find){
							find.isValid=true;		
							find.msg = this.$ml.get("analyzing_video");					
							
						}
					}

				}catch(error){
					console.warn("Error analyze video ", error)
				}finally{
					this.loading=false;
					this.info.loadingVideo=false;

				}
			},			
		},


	}
</script>